/* eslint-disable */
import * as types from './action_types';
import Immutable from 'immutable';
import { ServiceError } from '../../services/service_base';

export const initialState = Immutable.fromJS({
  done: [],
  notDone: [],
  queued: [],
  retrieving: false
});

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.USER_DONE_TACKS_RETRIEVING:
      return state.merge({ retrieving: true });
    case types.USER_NOT_DONE_TACKS_RETRIEVING:
      return state.merge({ retrieving: true });
    case types.USER_QUEUED_TACKS_RETRIEVING:
      return state.merge({ retrieving: true });
    case types.USER_DONE_TACKS_RETRIEVED:
      return state.merge({ done: action.finishedTacks, retrieving: false });
    case types.USER_NOT_DONE_TACKS_RETRIEVED:
      return state.merge({ notDone: action.unFinishedTacks, retrieving: false });
    case types.USER_QUEUED_TACKS_RETRIEVED:
      return state.merge({ queued: action.queuedTacks, retrieving: false });
    case types.USER_TACKS_RETRIEVAL_ERROR:
      const error = (action.error instanceof ServiceError) ? action.error.message : action.error;
      return state.merge({ error: error, retrieving: false });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/stores/user_tacks/reducer.js